import { Box, FactBox } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { FC } from 'react';

import { AboutFormData } from '../types';
import { ByggType } from '../../../../utils/registerEnums';

import { ByggtypeSelect } from './components/byggtypeSelect';
import { ConstructionYearField } from './components/constructionYearField';
import { FloorsField } from './components/floorsField';
import { AreaField } from './components/areaField';
import { BasementRadioGroup } from './components/basementField';
import { HeatedAreaField } from './components/heatedAreaField';
import { MaterialRadioGroup } from './components/materialRadioGroup';
import { HorizontalPlacementApartment, HorizontalPlacementRekkehusRadio } from './components/horizontalPlacementRadio';
import { VerticalPlacement, VerticalPlacementLeilighet } from './components/verticalPlacementRadio';

interface Props {
  control: Control<AboutFormData>;
  setValue: UseFormSetValue<AboutFormData>;
}

export const Info: FC<Props> = ({ control, setValue }) => {
  const { t } = useTranslation();
  const byggType = useWatch({ control, name: 'bygginfo.type' });

  const isLeilighet = byggType === ByggType.Leilighet;
  const isRekkehus = byggType === ByggType.Rekkehus;
  const isFiremannsbolig = byggType === ByggType.Firemannsbolig;
  const isHorisontaldeltTomannsbolig = byggType === ByggType.TomannsboligHorisontalDelt;

  return (
    <FactBox title={t('register.general.basicInformation.title')}>
      <Box display="flex" flexDirection="column" gap={3}>
        <ByggtypeSelect control={control} />

        {/* Horizontal placement is needed for leilighet and rekkehus */}
        {isLeilighet && <HorizontalPlacementApartment control={control} />}
        {isRekkehus && <HorizontalPlacementRekkehusRadio control={control} />}

        {/* Vertical placement is needed for leilighet, firemannsbolig and horisontaldelt tomannsbolig  */}
        {isLeilighet && <VerticalPlacementLeilighet control={control} />}
        {isFiremannsbolig && <VerticalPlacement control={control} />}
        {isHorisontaldeltTomannsbolig && <VerticalPlacement control={control} />}

        <ConstructionYearField control={control} />
        <FloorsField control={control} />
        <AreaField control={control} />
        <HeatedAreaField control={control} />
        <BasementRadioGroup control={control} setValue={setValue} />
        <MaterialRadioGroup control={control} />
      </Box>
    </FactBox>
  );
};
